import { nextAppClientEnvDefinition } from "./env-contracts/next-app.env-schema";
import { parseEnvSchema } from "./env-contracts/parse-env-schema";

export const clientEnv = parseEnvSchema(nextAppClientEnvDefinition, {
  source: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
    NEXT_PUBLIC_POSTHOG_MARKETING_CAPTURE_KEY:
      process.env.NEXT_PUBLIC_POSTHOG_MARKETING_CAPTURE_KEY,
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
    NEXT_PUBLIC_API_SIGNATURE_KEY: process.env.NEXT_PUBLIC_API_SIGNATURE_KEY,
  },
});
